module.exports = __webpack_public_path__ + "img/5.d1eeee96.jpg";